export default class CareCostHourly {
    static fromData(data) {
        if (!data) {
            return;
        }

        const careCostHourly = new CareCostHourly();
        careCostHourly.id = data.id;
        careCostHourly.title = data.title;

        return careCostHourly;
    }
}
